import Api from "../../lib/request";
import cookie from "../../lib/cookie";
import COOKIECONSTANT from "../../constant/cookie";
import { checkState } from "@roots/pLibrary/api/api.js";
const url = COOKIECONSTANT.REQUEST_HOST;
export const createOrderV2 = data =>
  new Promise((resolve, reject) => {
    Api.post(url, JSON.stringify(data), {
      headers: {
        "X-Host": "mall.order.create.v2",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(
      data => {
        resolve(checkState(data, 1, false) || false);
      },
      e => {
        reject(e);
      }
    );
  });
